export default {
    IdPaisEspania: '60',

    IdProvinciaCanariasList: ['35', '38'],

    IdProvinciaCeutaMelilla: ['51', '52'],

    SizeLimitDefault: '2',
};
